/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.connected.application.status.rpc.frontend.ConnectedStatusGraphQLService
 */

/* @bend-expect import-missing-runtime-dep */
import { useMemo } from 'react';
import {
  useQuery,
  useLazyQuery,
  useSuspenseQuery,
  QueryHookOptions,
  LazyQueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryResultTuple,
  QueryResult,
  UseSuspenseQueryResult,
  useMutation,
  MutationHookOptions,
  MutationTuple,
} from 'data-fetching-client';
import * as References from './ConnectedStatusGraphQLService';
import * as Queries from './ConnectedStatusGraphQLService.dfc.new';
import type { AdditionalContextArgs } from './ConnectedStatusGraphQLService.dfc.new';

type OverrideData<TTuple extends [any, any], TNewData> = [
  TTuple[0],
  Omit<TTuple[1], 'data'> & { data?: TNewData },
];

type MutationTupleOverride<Response, Request, DataOverride> = OverrideData<
  MutationTuple<Response, Request>,
  DataOverride
>;
type LazyQueryResultTupleOverride<
  Response,
  Request extends Record<string, any>,
  DataOverride,
> = OverrideData<LazyQueryResultTuple<Response, Request>, DataOverride>;

type UseFetchQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.FetchResponseType>,
    References.FetchRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<'fetch', References.FetchResponseType>
        : References.FetchResponseType)
    | undefined;
};

export function useFetchQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.FetchResponseType>,
    References.FetchRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseFetchQueryReturn<T> {
  const { data, ...rest } = useQuery(Queries.FETCH_QUERY, options);

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            fetch: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return { data: legacyFormatData, ...rest } as UseFetchQueryReturn<T>;
  }
  return { data: data?.result, ...rest } as UseFetchQueryReturn<T>;
}

type UseFetchLazyQueryReturn<T extends boolean> = LazyQueryResultTupleOverride<
  Record<'result', References.FetchResponseType>,
  References.FetchRequestType,
  T extends true
    ? Record<'fetch', References.FetchResponseType>
    : References.FetchResponseType
>;

export function useFetchLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.FetchResponseType>,
    References.FetchRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseFetchLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.FETCH_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            fetch: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseFetchLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseFetchLazyQueryReturn<T>;
}

type UseFetchSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.FetchResponseType>,
    References.FetchRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<'fetch', References.FetchResponseType>
    : References.FetchResponseType;
};

export function useFetchSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.FetchResponseType>,
    References.FetchRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseFetchSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(Queries.FETCH_QUERY, options);

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            fetch: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseFetchSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseFetchSuspenseQueryReturn<T>;
}

type UseFetchAllForUserQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.FetchAllForUserResponseType>,
    References.FetchAllForUserRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<'fetchAllForUser', References.FetchAllForUserResponseType>
        : References.FetchAllForUserResponseType)
    | undefined;
};

export function useFetchAllForUserQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.FetchAllForUserResponseType>,
    References.FetchAllForUserRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseFetchAllForUserQueryReturn<T> {
  const { data, ...rest } = useQuery(Queries.FETCH_ALL_FOR_USER_QUERY, options);

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            fetchAllForUser: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseFetchAllForUserQueryReturn<T>;
  }
  return { data: data?.result, ...rest } as UseFetchAllForUserQueryReturn<T>;
}

type UseFetchAllForUserLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.FetchAllForUserResponseType>,
    References.FetchAllForUserRequestType,
    T extends true
      ? Record<'fetchAllForUser', References.FetchAllForUserResponseType>
      : References.FetchAllForUserResponseType
  >;

export function useFetchAllForUserLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.FetchAllForUserResponseType>,
    References.FetchAllForUserRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseFetchAllForUserLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.FETCH_ALL_FOR_USER_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            fetchAllForUser: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseFetchAllForUserLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseFetchAllForUserLazyQueryReturn<T>;
}

type UseFetchAllForUserSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.FetchAllForUserResponseType>,
    References.FetchAllForUserRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<'fetchAllForUser', References.FetchAllForUserResponseType>
    : References.FetchAllForUserResponseType;
};

export function useFetchAllForUserSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.FetchAllForUserResponseType>,
    References.FetchAllForUserRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseFetchAllForUserSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.FETCH_ALL_FOR_USER_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            fetchAllForUser: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseFetchAllForUserSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseFetchAllForUserSuspenseQueryReturn<T>;
}

type UseDismissBatchMutationReturn<T extends boolean> = MutationTupleOverride<
  Record<'result', References.DismissBatchResponseType>,
  References.DismissBatchRequestType,
  T extends true
    ? Record<'dismissBatch', References.DismissBatchResponseType>
    : References.DismissBatchResponseType
>;

export function useDismissBatchMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.DismissBatchResponseType>,
    References.DismissBatchRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseDismissBatchMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.DISMISS_BATCH_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            dismissBatch: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseDismissBatchMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseDismissBatchMutationReturn<T>;
}

type UseDismissBatchForUserMutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<'result', References.DismissBatchForUserResponseType>,
    References.DismissBatchForUserRequestType,
    T extends true
      ? Record<
          'dismissBatchForUser',
          References.DismissBatchForUserResponseType
        >
      : References.DismissBatchForUserResponseType
  >;

export function useDismissBatchForUserMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.DismissBatchForUserResponseType>,
    References.DismissBatchForUserRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseDismissBatchForUserMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.DISMISS_BATCH_FOR_USER_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            dismissBatchForUser: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseDismissBatchForUserMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseDismissBatchForUserMutationReturn<T>;
}
